import { alpha, useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const GRIP_LENGTH = 24;
export const GRIP_THICKNESS = 6;
export const GRIP_GAP = 3;
// Deliberately thinner than the table's 12px bottom margin, so the rest of that margin stays clickable
// and the mouse can put the caret after a table that ends the content.
export const ADD_BAR_THICKNESS = 8;
// The row grip sits left of the table and the column grip above it, so the clipping root must reach
// slightly beyond the editor's box or the grips would be cut off.
export const OVERLAY_BLEED = 20;

export const useMentionInputTableControlsStyles = () => {
    const theme = useTheme();
    const grip = {
        position: "absolute" as const,
        borderRadius: GRIP_THICKNESS / 2,
        backgroundColor: theme.palette.grey[300],
        cursor: "grab",
        pointerEvents: "auto" as const,
        touchAction: "none" as const,
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
        },
    };
    const addBar = {
        position: "absolute" as const,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 1,
        color: theme.palette.text.secondary,
        fontSize: 12,
        // Keeps the hit area exactly the bar's size even though the icon is taller than the bar.
        overflow: "hidden" as const,
        cursor: "pointer",
        pointerEvents: "auto" as const,
        opacity: 0.6,
        "&:hover": {
            opacity: 1,
            backgroundColor: theme.palette.action.hover,
            color: theme.palette.primary.main,
        },
    };

    return createSxStyles({
        overlay: {
            position: "absolute",
            overflow: "hidden",
            pointerEvents: "none",
            zIndex: 1,
        },
        // The edge that sits against the table stays square so the bar reads as an extension of it.
        addRowBar: {
            ...addBar,
            height: ADD_BAR_THICKNESS,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
        },
        addColumnBar: {
            ...addBar,
            width: ADD_BAR_THICKNESS,
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
        },
        rowGrip: {
            ...grip,
            width: GRIP_THICKNESS,
            height: GRIP_LENGTH,
        },
        columnGrip: {
            ...grip,
            width: GRIP_LENGTH,
            height: GRIP_THICKNESS,
        },
        // A header row cannot be reordered, so its handle only opens the menu.
        gripNotDraggable: {
            cursor: "pointer",
        },
        gripDragging: {
            backgroundColor: theme.palette.primary.main,
            cursor: "grabbing",
        },
        dropIndicator: {
            position: "absolute",
            backgroundColor: theme.palette.primary.main,
            boxShadow: `0 0 0 1px ${alpha(theme.palette.primary.main, 0.3)}`,
            borderRadius: 1,
        },
        menuPaper: {
            minWidth: 220,
        },
    });
};
